import { Check, ArrowRight } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { PRICING } from "../lib/data";

export const Pricing = () => (
  <section id="tarifs" data-testid="pricing-section" className="py-20 md:py-28 bg-slate-50">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
      <Reveal className="text-center max-w-2xl mx-auto">
        <Overline>Tarifs</Overline>
        <h2 className="mt-4 font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900">
          Des formules claires, sans surprise
        </h2>
        <p className="mt-4 text-base text-slate-600 leading-relaxed">
          Tarifs indicatifs : chaque devis est gratuit, personnalisé et envoyé sous 24h après
          étude de votre bien.
        </p>
      </Reveal>

      <div className="mt-14 grid md:grid-cols-3 gap-6 lg:gap-8 items-stretch">
        {PRICING.map((p, i) => (
          <Reveal key={p.id} delay={i * 0.1} className="h-full">
            <div
              data-testid={`pricing-card-${p.id}`}
              className={`relative h-full rounded-3xl p-8 flex flex-col transition-transform duration-300 hover:-translate-y-1.5 ${
                p.highlighted
                  ? "bg-sky-600 text-white shadow-2xl shadow-sky-600/40 scale-[1.02]"
                  : "bg-white border border-slate-100 shadow-sm"
              }`}
            >
              {p.highlighted && (
                <span className="absolute -top-3.5 left-1/2 -translate-x-1/2 rounded-full bg-amber-400 text-amber-950 text-xs font-bold uppercase tracking-wider px-4 py-1.5 shadow">
                  Populaire
                </span>
              )}
              <h3 className="font-heading text-xl font-bold">{p.name}</h3>
              <p className={`mt-1 text-sm ${p.highlighted ? "text-sky-100" : "text-slate-500"}`}>{p.tagline}</p>
              <p className="mt-6 font-heading text-4xl font-extrabold tracking-tight">{p.price}</p>
              <ul className="mt-7 space-y-3 flex-1">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-2.5 text-sm">
                    <Check size={16} className={`mt-0.5 shrink-0 ${p.highlighted ? "text-amber-300" : "text-emerald-500"}`} />
                    <span className={p.highlighted ? "text-sky-50" : "text-slate-600"}>{f}</span>
                  </li>
                ))}
              </ul>
              <a
                href="#devis"
                data-testid={`pricing-card-${p.id}-cta`}
                className={`mt-8 inline-flex items-center justify-center gap-2 rounded-full font-semibold px-6 py-3 text-sm transition-colors ${
                  p.highlighted
                    ? "bg-white text-sky-700 hover:bg-sky-50"
                    : "bg-sky-600 text-white hover:bg-sky-700"
                }`}
              >
                {p.cta} <ArrowRight size={15} />
              </a>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
